import { ReactNode } from 'react';

import { Stack } from '@mui/material';

import ChevronUpIcon from '../../../../../icons/ChevronUpIcon';
import { Props as ButtonProps } from '../../../../../components/Button';
import { Content, Header, Root } from './styles';
import useAccordion from './vm';

export interface AccordionProps {
  /**
   * This property will be automatically controlled by AccordionGroup
   * DO NOT SET IT MANUALLY
   * @default false
   */
  isOpen?: boolean;
  /**
   * This property should be a unique identifier for each accordion
   * Helps AccordionGroup to identify which accordion is open
   */
  identifier: string;
  header: ReactNode;
  /** Applied to header */
  onClick?: ButtonProps['onClick'];
  children: ReactNode;
  className?: string;
}

const Accordion = ({ isOpen = false, header, onClick, children, className }: AccordionProps) => {
  useAccordion();

  return (
    <Root isOpen={isOpen} className={className}>
      <Header endIcon={isOpen ? <ChevronUpIcon /> : null} onClick={onClick}>
        {header}
      </Header>
      <Content isOpen={isOpen}>
        <Stack overflow="auto">{children}</Stack>
      </Content>
    </Root>
  );
};

export default Accordion;
